import AxiosClient from './clients/axios'

const resource = 'integrations/mobly/services/cs'

const findGeneralConfigWorkflowMappers = async () => {
  const url = `${resource}/generalConfigWorkflowsMapper`

  const response = await AxiosClient.get(url)

  return response.data
}

export {
  findGeneralConfigWorkflowMappers
}
